import { render, staticRenderFns } from "./EdgeHeader.vue?vue&type=template&id=2bafe7a8&scoped=true&"
import script from "./EdgeHeader.vue?vue&type=script&lang=js&"
export * from "./EdgeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bafe7a8",
  null
  
)

export default component.exports